import React from "react";
import {AbsoluteFill, Series, useVideoConfig} from "remotion";
import {VideoClip} from "./VideoClip";

export interface Segment {
  startSeconds: number;
  endSeconds: number;
}

export interface JumpCutProps {
  src: string;
  segments: Segment[];
  paddingSeconds?: number;
  volume?: number;
  fit?: "cover" | "contain" | "fill";
  muted?: boolean;
  style?: React.CSSProperties;
}

export const JumpCut: React.FC<JumpCutProps> = ({
  src,
  segments,
  paddingSeconds = 0.1,
  volume = 1,
  fit = "cover",
  muted = false,
  style,
}) => {
  const {fps} = useVideoConfig();

  if (segments.length === 0) return null;

  return (
    <AbsoluteFill style={style}>
      <Series>
        {segments.map((segment, i) => {
          const start = Math.max(0, segment.startSeconds - paddingSeconds);
          const end = segment.endSeconds + paddingSeconds;
          const durationSeconds = end - start;
          const durationInFrames = Math.round(durationSeconds * fps);

          if (durationInFrames <= 0) return null;

          return (
            <Series.Sequence key={i} durationInFrames={durationInFrames}>
              <VideoClip
                src={src}
                trimStartSeconds={start}
                trimEndSeconds={end}
                volume={volume}
                fit={fit}
                muted={muted}
              />
            </Series.Sequence>
          );
        })}
      </Series>
    </AbsoluteFill>
  );
};

/** Calculate the total duration in frames for a JumpCut */
export const calculateJumpCutDuration = (
  segments: Segment[],
  fps: number,
  paddingSeconds = 0.1,
): number => {
  return segments.reduce((total, seg) => {
    const start = Math.max(0, seg.startSeconds - paddingSeconds);
    const end = seg.endSeconds + paddingSeconds;
    return total + Math.round((end - start) * fps);
  }, 0);
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
